import React, { useState } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RegisterModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false); // Success popup ke liye state

  if (!isOpen) return null;

  const handleRegisterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.currentTarget);
    const data = {
      student_name: formData.get('student_name'),
      email: formData.get('email'),
      school_name: formData.get('school_name'),
      contact_number: formData.get('contact_number'),
    };

    try {
      const response = await fetch('http://api.bestcoachinginjalandhar.com/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setIsSuccess(true); // Alert ki jagah success state true karein
      } else {
        alert("Server error, please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Could not connect to server.");
    } finally {
      setLoading(false);
    }
  };

  // Close handle function jo state ko reset karega
  const handleFinalClose = () => {
    setIsSuccess(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      
      {/* --- SUCCESS MESSAGE POPUP --- */}
    {isSuccess ? (
        <div className="relative w-full max-w-sm overflow-hidden rounded-2xl bg-white p-8 text-center shadow-2xl animate-in zoom-in duration-300">
          <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-black text-gray-800 mb-2">Registration Successful!</h2>
          <p className="text-gray-600 mb-8 text-sm leading-relaxed">
            Thank you for registering with us. Our academic team has received your details and will get in touch with you very soon.
          </p>
          <button 
            onClick={handleFinalClose}
            className="w-full bg-[#d01921] text-white py-3.5 rounded-xl font-bold hover:bg-[#b5141b] transition-all active:scale-95 shadow-lg shadow-red-100 uppercase tracking-widest text-xs"
          >
            Got it, Thanks!
          </button>
        </div>
      ) : (
        /* --- ORIGINAL REGISTRATION FORM --- */
        <div className="relative w-full max-w-sm overflow-hidden rounded-xl bg-white shadow-2xl animate-in fade-in duration-200">
          <div className="h-1.5 w-full bg-[#d01921]"></div>

          <div className="p-6">
            <button 
              onClick={onClose} 
              className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-gray-50 text-gray-400 transition-colors hover:bg-gray-100 hover:text-black"
            >
              <span className="text-xl">&times;</span>
            </button>

            <div className="mb-6 text-center">
              <h2 className="text-xl font-bold tracking-tight text-[#1e3a8a]">Registration Open</h2>
              <div className="mt-1.5 inline-block rounded border border-dashed border-[#1e3a8a]/40 bg-blue-50 px-3 py-0.5">
                <p className="text-[10px] font-bold text-[#1e3a8a] uppercase tracking-wider">Limited Seats Available</p>
              </div>
            </div>

            <form className="space-y-3.5" onSubmit={handleRegisterSubmit}>
              <div className="space-y-1">
                <label className="text-[11px] font-bold text-gray-500 uppercase ml-1">Student Name</label>
                <input name="student_name" type="text" placeholder="Full name" className="w-full rounded-md border border-gray-200 bg-gray-50 p-2.5 text-sm outline-none focus:border-[#d01921] focus:ring-1 focus:ring-[#d01921]/10" required />
              </div>

              <div className="space-y-1">
                <label className="text-[11px] font-bold text-gray-500 uppercase ml-1">Email</label>
                <input name="email" type="email" placeholder="example@mail.com" className="w-full rounded-md border border-gray-200 bg-gray-50 p-2.5 text-sm outline-none focus:border-[#d01921] focus:ring-1 focus:ring-[#d01921]/10" required />
              </div>

              <div className="space-y-1">
                <label className="text-[11px] font-bold text-gray-500 uppercase ml-1">School Name</label>
                <input name="school_name" type="text" placeholder="School name" className="w-full rounded-md border border-gray-200 bg-gray-50 p-2.5 text-sm outline-none focus:border-[#d01921] focus:ring-1 focus:ring-[#d01921]/10" required />
              </div>

              <div className="space-y-1">
                <label className="text-[11px] font-bold text-gray-500 uppercase ml-1">Contact Number</label>
                <div className="flex gap-1.5">
                  <span className="flex items-center rounded-md border border-gray-200 bg-gray-100 px-2.5 text-xs text-gray-500 font-bold">+91</span>
                  <input name="contact_number" type="tel" placeholder="9876543210" className="w-full rounded-md border border-gray-200 bg-gray-50 p-2.5 text-sm outline-none focus:border-[#d01921] focus:ring-1 focus:ring-[#d01921]/10" required />
                </div>
              </div>

              <button 
                disabled={loading}
                className="mt-3 flex w-full items-center justify-center rounded-lg bg-[#d01921] py-3 text-sm font-bold text-white transition-all hover:bg-[#b5141b] active:scale-[0.98] shadow-md shadow-red-100 disabled:opacity-70"
              >
                {loading ? "PROCESSING..." : "REGISTER NOW"}
              </button>
            </form>

            <p className="mt-5 text-center text-[9px] text-gray-400 leading-tight">
              By clicking register, you agree to our <br/> Terms & Conditions.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterModal;